export enum StatusCode {
  NotFoundError = 404,
  InternalServerError = 500,
  BadGatewayError = 502,
  GatewayTimeoutError = 504
}
